/** Single source of the application version (kept in sync with package.json by a unit test). */
export const APP_VERSION = '0.1.0';
